module.exports = __webpack_public_path__ + "static/img/overduing_icon.e8fa4935.png";